export { };
export const defaults = {
	addSelector: '.js-add-iban',
	closeSelector: '.js-close-iban',
	dummySelector: '.js-iban-dummy-wrapper',
	fancyboxSelector: '.js-fancybox',
	resultSelector: '.js-iban-result-wrapper',
	selector: '#iban_rechner',
	submitSelector: '.js-submit-iban',
	ibanInputSelector: 'Bankdaten.Iban',
	bicInputSelector: 'Bankdaten.Bic',
	app: {
		validatorRules: {
			rules: {
				Zahlungsweise: {
					required: true,
				},
				Bankleitzahl: {
					number: true,
					required: true,
					minlength: 8,
					maxlength: 8,
					customflagvalidation: true
				},
				Kontonummer: {
					number: true,
					required: true,
					maxlength: 10,
					customflagvalidation: true
				},
				"Bankdaten.Iban": {
					required: true,
					customiban: true,
					maxlength: 42,
					customflagvalidation: true,
					oneibanrequired: false
				},
				"Bankdaten.Bic": {
					required: true,
					maxlength: 11,
					customflagvalidation: true
				},
				HatAbweichendenKontoInhaber: {
					required: true,
					customflagvalidation: true
				},
				ErmaechtigungLastschrift: {
					required: true
				},
				Anrede: {
					required: true,
					customflagvalidation: true
				},
				Vorname: {
					required: true,
					maxlength: 40,
					customflagvalidation: true,
					nonumber: true,
					pattern: /^[^\(\)\%\\\~\"\?\#]*$/
				},
				Nachname: {
					required: true,
					maxlength: 40,
					customflagvalidation: true,
					nonumber: true,
					pattern: /^[^\(\)\%\\\~\"\?\#]*$/
				},
				StrasseHausnummer: {
					required: true,
					minlength: 2,
					maxlength: 30,
					streetandnumber: true,
					customflagvalidation: true
				},
				Postleitzahl: {
					number: true,
					required: true,
					minlength: 5,
					maxlength: 5,
					customflagvalidation: true
				},
				Ort: {
					pattern: /^[a-zA-ZäöüÄÖÜßéèêóòúù\-\/\.\s()]+$/,
					required: true,
					maxlength: 30,
					customflagvalidation: true
				}
			}
		},
		validationmessages: {
			client: {
				pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
				required: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
				streetandnumber: "Bitte geben sie den Strassennamen und die Hausnummer an.",
				phonecross: "Bitte Vorwahl und Rufnummer angeben.",
				workphonecross: "Bitte Vorwahl und Rufnummer angeben.",
				customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!",
				Zahlungsweise: {
					required: "Bitte wählen Sie eine Zahlungsweise.",
				},
				Bankleitzahl: {
					number: "Bitte nur Zahlen eingeben.",
					required: "Die Bankleitzahl muss ausgefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					minlength: "Bitte mindestens {0} Zahlen",
					maxlength: "Bitte maximal {0} Zahlen",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!"
				},
				Kontonummer: {
					number: "Bitte nur Zahlen eingeben.",
					required: "Die Kontonummer muss ausgefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					maxlength: "Bitte maximal {0} Zahlen",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!"
				},
				Anrede: {
					required: "Bitte geben Sie Ihre Anrede ein.",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!"
				},
				Vorname: {
					minlength: "Bitte mindestens {0} Buchstaben",
					maxlength: "Bitte maximal {0} Buchstaben",
					required: "Sie haben keinen Vornamen eingegeben. Bitte korrigieren Sie ihre Eingabe!",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!",
					nonumber: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				Nachname: {
					minlength: "Bitte mindestens {0} Buchstaben",
					maxlength: "Bitte maximal {0} Buchstaben",
					required: "Sie haben keinen Nachname eingegeben. Bitte korrigieren Sie ihre Eingabe!",
					nonumber: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!",
					pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				StrasseHausnummer: {
					streetandnumber: "Bitte korrigieren Sie Ihre Eingabe! Erlaubt sind folgende Sonderzeichen: .,-/’.",
					required: "Bitte geben Sie den Straßennamen und die Hausnummer ein",
					minlength: "Bitte geben Sie mindestens {0} Zeichen ein.",
					maxlength: "Bitte geben Sie maximal {0} Zeichen ein.",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!"
				},
				Ort: {
					pattern: "Bitte prüfen Sie Ihre Eingabe.",
					maxlength: "Bitte maximal {0} Zeichen",
					required: "Bitte geben Sie die gültige Postleitzahl und den Wohnort ein.",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!"
				},
				Postleitzahl: {
					number: "Bitte nur Zahlen eingeben.",
					maxlength: "Bitte maximal {0} Zahlen",
					minlength: "Bitte mindestens {0} Zahlen",
					required: "Bitte geben Sie die gültige Postleitzahl ein.",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!"
				},
				"Bankdaten.Iban": {
					required: "Bitte geben Sie eine gültige IBAN ein!",
					customiban: "Bitte geben Sie eine gültige IBAN ein!",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!",
					oneibanrequired: "Bitte geben Sie mindestens eine Iban an."
				},
				"Bankdaten.Bic": {
					required: "Bitte geben Sie eine gültige BIC ein!",
					customflagvalidation: "Bitte prüfen Sie Ihre Eingabe!"
				},
				HatAbweichendenKontoInhaber: {
					required: "Bitte prüfen Sie Ihre Eingabe!"
				},
				ErmaechtigungLastschrift: {
					required: "Bitte bestätigen Sie Ihre Einzugsermächtigung"
				}
			},
			backend: {
				code_110007: "Ungültige Daten"
			}
		}
	}
};